"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=stock-transfer.dto.js.map